// Header.js
// Header.js
import "./Header.scss";
import React from "react";
import { Link } from "react-scroll";
// import logo from "../../assets/logo.png"; // Replace with the actual path to your logo
import logo2 from "../../assets/logo2.png"; // Replace with the actual path to your logo
import { useTheme } from "../Theme/ThemeContext";
import moon from "../../assets/moon.png"; // Replace with the actual path to your logo
import sun from "../../assets/sun.png"; // Replace with the actual path to your logo
import { useState } from "react";

const Header = () => {
  const { darkMode, toggleTheme } = useTheme();

  const [menu, setmenu] = useState(true);
  const changemenu = () => {
    setmenu(!menu);
  };

  return (
    <header className={`Header ${menu ? "" : "hide"}`}>
       
       <div className="menu-toggle" onClick={changemenu}></div>
        
       
      <div className="res-header">


        <img
          className="theme-icon"          src={`${darkMode ? sun : moon}`}
          alt="theme" width={50} height={50} onClick={toggleTheme}/>
        <nav>
       
       <Link className='home link' to="home" smooth={true} duration={1000}  offset={-0}>Home</Link>
       <Link className='link' to="about" smooth={true} duration={1000}   offset={-0}>About</Link>
       <Link className='link' to="education" smooth={true} duration={1000}   offset={-0}>Education</Link>
       <Link className='link'to="projects" smooth={true} duration={1000} offset={-0}>Projects</Link>
       <Link className='link'to="skills" smooth={true} duration={1000} offset={-0}>Skills</Link>
       <Link className='link'to="Experience" smooth={true} duration={1000} offset={50}>Experience</Link>
       <Link className='link'to="Languages" smooth={true} duration={1000} offset={-0}>Languages</Link>
       <Link className='link'to="contact" smooth={true} duration={1000} offset={-0}>Contact</Link>
     </nav>
      </div>




      <Link
          className="link"
          to="home"
          smooth={true}
          duration={1000}
          offset={-20}
        >
          <div className="logo">
            <img className="ll1" src={"https://lh3.googleusercontent.com/fife/ALs6j_EN14VbAdxRMnk2KrURT4XBd8BO2ajFg83xyKoLLQv6gUq_jLo3ZZok0swmlQNG6GZUtXpwJFh1WTKmj1lcTc9tsY-Evr10M5FBw3ZTfVUUzXlTS8GCoyPuwVnU6npV7UN_kAaH8lpQ_DgrZX_W-HrzmucVAv73N97VYl85_njY5cHc0A3n_UbP2XGWnYi6x9VsSlEHqKQC33IQ7eBoWKzc0oPlVdG5zLB9QxZmrg-1My1NYDUHNtb3hoQwZOkqOQqDJlCs5PDG5X1s4mIBsX_rS5VhhT2gMEovak4FdoU7KrugadzPcyWf_PTmoSggD5UL_FKKCuHFc8kB8LMxxvsacu8A1K8weaYlUwfMz3N24f8UOtRbaALRXwGYgpuMAfJv2XaoT4z-e-0rhJhesCed5eDzWziPuigahNF2rwM_FHJxY4moSqrwONhYAJIkWXD4axxwFeCCDeMce2D0X1pdWjWuJJR0KFvXJ2tOg3Lq2UCz8jN6657Ypc3AstIBlFGf3_C208qUa3DTlRkdUGpuE-LmwIkmBhmhxyIVQ6rWK0QMDe1Jrll6ZK9kNWN301wBVd-YZ7yxkxkIygB9fdjq1pT4zvM9_RhfYGKrc2VokrXDyRjSz1UMIntGILo0rmspiFUBrLjF8DWn7mLj4oknWz8fzxKrbck4gjISDvGPXVFwEqZyvJdIYyeFBgFV7zyk3Q_7CVuPENROxRriGfyb0x-6kQQWWvTOyfTyIha50oL_SWpkHzg3PuqZPhFYc-76UG7A9-vu2TPZYVmPSawEEFwAbw-bMx4skl6APcyhYTRTkZVF_3pmPHh_s7MFWg-vstqWG6Z1_fJko_1FRKqiANDcyZqIWmg5hbFl08A3Hkka0Rw9UyHQ9U0RQvGrobu_OZsxXjlln2SrlxNR-NFiPc1PLYqVnUptAMaBdEI1VMU83Mq9niZf3_Htf5s47hLjRBWlM4VIMEOJT4tcUqEv6S3OrHyYCqBwhV0stCkiWWQ2VVGz58OuCWnOAu7asH8uUNQRYowcGyAwPAGj4ykeGqEm5tKm8dOPztB9Iv7ZDks3XlD36dmVp9vIMtgTDrEbWle26KBhip0dpnVxOmrSNIHQpcwTsOmOehm15faT1-4YlN56VfYr_P0T5aZ6alZds6ugzA_qvIeTHcsYez1OGQT9oW_eeLIFo881gk3WzY4a07TdwI6r-GqgXxxo4SAz_Z-SS9ubAfrbB4hKW7Hrn8IJ4Xal7aUhU1n4I9J5yHMCflQvkIQth7fPy4m00cJzzu4Ai7deyDOzFoOiwxV49M2KFlpecpyckTXBnayobTEjgX03zfhpKUmNgJi6TB3m5Xo-4GGOyLa5hI9a-s0viVWYv02oxIdcIAbMWlHxUyhGaH2FS8nPsO4H4zm7ZQ0LCeutLtyD8EdrrhBPwD0SppcSpdnSaPfUYuIMBr9VdJwXgLMc1knsQ6qeyXRM_Rq3_u_U-EtWGQv1F9udQLh0FGr5iKDHP4ZJ5jeGz8FNb2k4peoQdYdN95cZ-q6M3k4Sp4rZ_cRssuC7Au8nWswhPTMqLsp9qhesiutS8zWDUxuqgkik4aIO4ZorY0WgIFaKKZD9rs5q1NiY4A=w831-h937"} alt="Logo" />
            <img className="ll2" src={"https://lh3.googleusercontent.com/u/0/drive-viewer/AKGpihY2aCvSaKw1icVFMoqgb56EH_YhzjYW8JVD86r2bZpV1nEMG8g_gYEBcV79IY-TT-eUsoBdkNLw02wmp2PYLekGsnnq42XwL2g=w1322-h969-rw-v1"} alt="Logo2" />
          </div>
        </Link>
    </header>
  );
};

export default Header;
